<template>
  <el-dialog
    title="Редактировать платежное лицо"
    :visible="visible"
    :close-on-click-modal="false"
    @update:visible="updateVisible"
    @open="handleDialogOpen">
    <el-form
      ref="form"
      :rules="rules"
      :model="formData"
      label-position="top"
      @submit.native.prevent="onSubmit">
      <el-form-item class="mt-12" label="Тип организации" prop="orgType">
        <el-select v-model="formData.orgType">
          <el-option
            v-for="type in orgTypes"
            :key="type.id"
            :label="type.label"
            :value="type.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="ИНН" prop="inn">
        <el-input v-model="formData.inn" name="inn" />
      </el-form-item>
      <el-form-item label="Название организации" prop="orgName">
        <el-input v-model="formData.orgName" name="orgName" />
      </el-form-item>
      <el-form-item label="Фактический адрес" prop="factAddress">
        <el-input v-model="formData.factAddress" name="factAddress" />
      </el-form-item>
      <el-form-item label="Юридический адрес" prop="legalAddress">
        <el-input v-model="formData.legalAddress" name="legalAddress" />
      </el-form-item>
      <el-form-item>
        <el-checkbox
          v-model="formData.isPrimary"
          label="Основное платежное лицо"
          :disabled="formData.isPrimary"
          name="isPrimary" />
      </el-form-item>
      <el-form-item>
        <el-radio-group v-model="formData.documentReceive">
          <el-radio label="mail">Получать документы на почту</el-radio>
          <el-radio label="edo">Получать документы по ЭДО</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="divider" />
      <div class="flex-x-center">
        <el-button
          :loading="$mip('editRequisite')"
          type="primary"
          native-type="submit">
          Сохранить
        </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import { cloneDeep } from 'lodash-es'

  export default {
    props: {
      visible: Boolean,
      requisite: Object,
      orgTypes: Array
    },

    data() {
      return {
        rules: {
          orgType: [
            { required: true, message: 'Пожалуйста, выберите тип организации', trigger: 'blur' }
          ],
          inn: [
            { required: true, message: 'Пожалуйста, введите ИНН', trigger: 'blur' }
          ],
          orgName: [
            { required: true, message: 'Пожалуйста, введите название организации', trigger: 'blur' }
          ],
          factAddress: [
            { required: true, message: 'Пожалуйста, введите фактический адрес', trigger: 'blur' }
          ],
          legalAddress: [
            { required: true, message: 'Пожалуйста, введите юридический адрес', trigger: 'blur' }
          ]
        },
        formData: {
          orgType: '',
          inn: '',
          orgName: '',
          factAddress: '',
          legalAddress: '',
          isPrimary: false,
          documentReceive: 'mail'
        }
      }
    },

    methods: {
      handleDialogOpen() {
        this.formData = cloneDeep(this.requisite)
      },

      onSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.editRequisite()
          } else {
            console.error('Error: form validation')
            return false
          }
        })
      },

      async editRequisite() {
        await this.$http.editRequisite(this.formData)
        this.updateVisible(false)

        this.$notify(
          {
            type: 'success',
            title: 'Редактирование лица',
            message: 'Платежное лицо отредактировано'
          }
        )

        this.$emit('update-list')
      },

      updateVisible(val) {
        this.$emit('update:visible', val)
      }
    }
  }
</script>